import { useToastStore } from '@/stores/toastStore';
import { Toast } from './Toast';

export function ToastContainer() {
  const toasts = useToastStore((s) => s.toasts);
  const removeToast = useToastStore((s) => s.removeToast);

  if (toasts.length === 0) return null;

  return (
    <div
      aria-live="polite"
      // Spec: "Toast placement: top of screen, below sticky header,
      // auto-dismiss after 3 seconds." We center horizontally and
      // offset 56px to clear the SettingsSubPage / Plan sticky header.
      // Sticky-header containers across the app are 48–56px tall, so
      // 64px (top-16) leaves a small gap on every page.
      //
      // `items-center`: the toast is a fixed 362px card, so on any viewport
      // wider than 362 + 32 it sat flush left in this full-width column with
      // the slack all on the right ("Left household" on the signed-out
      // landing, YAR-145).
      className="fixed top-16 left-1/2 -translate-x-1/2 z-[400] flex flex-col items-center gap-2 px-4 max-w-md w-full pointer-events-none"
    >
      {toasts.map((t) => (
        <div
          key={t.id}
          className="pointer-events-auto"
        >
          <Toast
            variant={t.variant}
            message={t.message}
            description={t.description}
            actionLabel={t.action?.label}
            onAction={
              t.action
                ? () => {
                    const action = t.action;
                    removeToast(t.id);
                    action?.onAction();
                  }
                : undefined
            }
            onDismiss={() => removeToast(t.id)}
          />
        </div>
      ))}
    </div>
  );
}
